<template>
  <div class="sucess" >
     <div class="suc">
            <span>{{waring}}</span>
        </div>
  </div>
</template>
<script>
export default {
  props: {
    waring: {
      default: () => {
        return '敬请期待'
      },
      type: String,
      required: false
    }
  },
  methodes: {
  }
}
</script>
<style scoped>
  .sucess{
    display:flex;
    justify-content: center;
    align-items: center;
    width:100%;
    height:100%;
    background-color:rgba(0,0,0,.5);
    position:fixed;
    top:0;
    left:0;
    z-index:9999
  }
  .suc{
    color:#434F55;
    display:flex;
    justify-content: center;
    align-items: center;
    font-size: 1.25rem;
    font-weight:500;
    width:368px;
    height:125px;
    background:rgba(255,255,255,1);
    border-radius:2px;
  }
  .suc .sucicon{
    width: 3.75rem;
    height:3.75rem;
  }
  .suc span{
    margin-left:1.375rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/warning/expect.vue